import Controller from 'controllers/controller';
import CarouselController from 'controllers/carousel';
import FadingGalleryController from 'controllers/fading-gallery';
import Binder from 'tools/binder';

class LocationsController extends Controller {
    constructor(app) {
        super(app);
        
        this.root = document.querySelector('.page[data-template="locations"]');
        this.binder = new Binder(this);

        this.elements = { };
        this.carousel = null;

        this.app.loaderController.on('locations-loaded', () => {
            this.cacheElements();
            // this.setButtonSrc();
            this.initCarousel();
            this.initGalleries();
            this.attachEvents();
        })
    }

    cacheElements() {
        this.elements.srButton = document.getElementById('sr-res-root');
        this.elements.carousel = this.root.querySelector('.carousel');
        this.elements.galleries = Array.from(this.root.querySelectorAll('.fading-gallery'));
        this.elements.bookATableButtons = Array.from(this.root.querySelectorAll('.book-a-table'));
        this.elements.webLinkButtons = Array.from(this.root.querySelectorAll('.web-link'));
    }
    
    attachEvents() {
        this.elements.bookATableButtons.forEach(button => {
            button.addEventListener('click', this.binder.bind('onBookATableClick'));
        });

        this.elements.webLinkButtons.forEach(button => {
            button.addEventListener('click', this.binder.bind('onWebLinkClick'));
        });
    }

    // setButtonSrc() {
    //     let src = this.app.bookATableController.getIframeSrc();
    //
    //     this.elements.bookATableButtons.forEach(button => {
    //         button.setAttribute('href', src);
    //     });
    // }

    onBookATableClick(event) {
        event.preventDefault();
        this.elements.srButton.click();
    }

    // onBookATableClick(event) {
    //     if (this.app.iOSDevice || this.app.isSafari) {
    //         return;
    //     }
    //
    //     event.preventDefault();
    //
    //     this.app.modalsController.openModal('book-a-table');
    // }

    onWebLinkClick(event) {
        event.preventDefault();

        let link = event.currentTarget,
            url = link.getAttribute('href');

        this.app.pageController.scrollToPage(
            this.app.pageController.getPageByUrl(url)
        );
    }

    initCarousel() {
        this.carousel = this.app.make(CarouselController, this.elements.carousel, {
            wrapAround: true
        });
    }

    initGalleries() {
        this.elements.galleries.forEach(gallery => {
            gallery.galleryController = this.app.make(FadingGalleryController, gallery);
        })
    }
}

export default LocationsController;